import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core'
import InfoOutlined from '@material-ui/icons/InfoOutlined'
import React from 'react'

import { fetchSops } from 'api/procurement'
import { DEFAULT_SOPS, SOP_SECTIONS } from '../constants'

const labelFor = (category) => {
  const found = SOP_SECTIONS.find((c) => c.key === category)
  return found ? found.label : 'Procurement'
}

// Small (i) button shown beside Save draft on each centre form. Opens a dialog
// with that category's SOP (how-to-use guidance). Text is HQ-editable from the
// HQ -> SOP tab; we lazy-load it on first open and fall back to the seeded
// default if the API has no row yet. The dialog renders in a portal (outside the
// procurement lowercase wrapper) so the SOP shows in normal sentence case.
const SopButton = ({ category }) => {
  const [open, setOpen] = React.useState(false)
  const [content, setContent] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  const load = async () => {
    setLoading(true)
    try {
      const res = await fetchSops()
      const rows = res?.results || []
      const row = rows.find((s) => s.category === category)
      setContent((row && row.content) || DEFAULT_SOPS[category] || '')
    } catch (e) {
      setContent(DEFAULT_SOPS[category] || '')
    } finally {
      setLoading(false)
    }
  }

  const onOpen = () => {
    setOpen(true)
    if (content === null) load()
  }

  return (
    <>
      <Tooltip title="How to use this page">
        <IconButton size="small" aria-label="how to use" onClick={onOpen}>
          <InfoOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{`How to use — ${labelFor(category)}`}</DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <CircularProgress size={22} />
          ) : (
            <Typography
              variant="body2"
              component="div"
              style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
              {content}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SopButton
